
const Finish = ():JSX.Element => {
    return (
        <div>Finish</div>
    )
} 

export default Finish